export type AnimationTargetPath = "translation" | "rotation" | "scale";

export type AnimationChannel = {
  nodeIndex: number;
  path: AnimationTargetPath;
  interpolation: "STEP" | "LINEAR" | "CUBICSPLINE";
  times: Float32Array;
  values: Float32Array;
};

export type ClipRootMotionExtents = {
  forward_xz: number;
  vertical_y: number;
  side_x: number;
};

export default class AnimationClip {
  name: string;
  duration: number;
  channels: AnimationChannel[];
  rootMotionNodeIndex: number;
  hierarchyRootNodeIndex:number;
 
  root_motion_extents: ClipRootMotionExtents = {
    forward_xz: 0,
    vertical_y: 0,
    side_x: 0,
  };

  constructor(
    name: string,
    duration: number,
    channels: AnimationChannel[],
    rootMotionNodeIndex: number,
    hierarchyRootNodeIndex:number,
  ) {
    this.name = name;
    this.duration = duration;
    this.channels = channels;
    this.rootMotionNodeIndex = rootMotionNodeIndex;
    this.hierarchyRootNodeIndex = hierarchyRootNodeIndex;
  }

     printf()
  {
    return this.name+ " duration: "+this.duration;
  }

  log()
  {
    console.log(this.name+ " rootMotionNodeIndex:"+this.rootMotionNodeIndex);
    for(var i = 0; i < this.channels.length; i++)
    {
        console.log(this.channels[i])
    }
    
  }
}
